<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
   <tr>
      <td><label>{{ $t('generic.business_day') }}</label></td>
      <td>{{ details.business_day | dateOnly }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.inspector_team_id') }}</label></td>
      <td>
        <router-link v-if="$auth.can({inspector_team: 'read'}, 'permissions')"
                     :to="inspectorTeamLink(details.inspector_team_id)">{{
            details.inspector_team_id
          }}
        </router-link>
        <span v-else>{{ details.inspector_team_id }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.system_account_id') }}</label></td>
      <td>
        <router-link v-if="$auth.can({system_account: 'read'}, 'permissions')"
                     :to="systemAccountLink(details.system_account_id)">{{
            details.system_account_id
          }}
        </router-link>
        <span v-else>{{ details.system_account_id }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.account_id') }}</label></td>
      <td>
        <router-link v-if="details.account_id" :to="accountJourneysPathLink(details.account_id)">{{
            details.account_id
          }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.ticket_id') }}</label></td>
      <td>
        <router-link v-if="details.account_id && details.ticket_id"
                     :to="accountTicketLink(details.account_id, details.ticket_id)">{{
            details.ticket_id
          }}
        </router-link>
        <span v-else>{{ details.ticket_id }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.message') }}</label></td>
      <td>{{ details.message }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('inspection_event.details.metadata') }}</label></td>
      <td>
        <meta-data-details :data="details.metadata"/>
      </td>
    </tr>
  </table>
</template>
<script>
import linkUtils from "@/util/link_utils";
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: 'inspectionEventDetails',
  components: {MetaDataDetails},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    accountJourneysPathLink(accountID) {
      return linkUtils.accountJourneysPath(this.$router, {account_id: accountID});
    },
    systemAccountLink(systemAccountID) {
      return linkUtils.systemAccountPath(this.$router, {system_account_id: systemAccountID});
    },
    inspectorTeamLink(id) {
      return linkUtils.inspectorTeamPath(this.$router, {inspector_team_id: id});
    },
    accountTicketLink(account_id, id) {
      return linkUtils.accountTicketPath(this.$router, {account_id: account_id, id: id});
    },
  }
};
</script>
<style>
</style>
